import React from 'react';
import { Button, Dropdown } from 'antd';
import { CloseCircleOutlined, DownCircleOutlined } from '@ant-design/icons';

const Action = ({ row, action, modalForm, modalDelete }) => {
    const items = [];

    if (!action.update) {
        return "-";
    }

    if (action.detail_delete) {
        items.push({
            key: '2',
            label: "Delete",
            icon: <CloseCircleOutlined />,
            onClick: () => modalDelete(true, row),
        });
    }

    return (
        <Dropdown
            trigger={['click']}
            menu={{ items }}
        >
            <Button type="primary">
                Opsi <DownCircleOutlined style={{ fontSize: 11 }} />
            </Button>
        </Dropdown>
    );
};

export default Action;
